export default function getVimeoIdFromUrl(url) {
  return !!url ? /vimeo.*\/(\d+)/i.exec(url)[1] : "";
}
